import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';

import { gameStore } from '../../../store';
import { Timer } from '../../../components/common/timer';

export const TimerWrapper = observer(({ time }) => {
  const { isBetsClosed } = gameStore;
  const { duration } = roundInfoStore;

  return <Timer duration={duration} time={time} isBetsClosed={isBetsClosed} />;
});
